/*
 * <before-after-stories>: steps through [data-slide] children with the prev/next arrows, looping at the ends.
 * Selecting a story block in the theme editor jumps to that story.
 */
if (!customElements.get('before-after-stories')) {
  customElements.define(
    'before-after-stories',
    class BeforeAfterStories extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.counter = this.querySelector('[data-current]');
        this.index = 0;
        if (this.slides.length < 2) return;

        this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1));

        this.onBlockSelect = this.onBlockSelect.bind(this);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onBlockSelect(event) {
        const index = this.slides.indexOf(event.target);
        if (index > -1) this.show(index);
      }

      show(index) {
        const previous = this.slides[this.index];
        previous.hidden = true;
        previous.classList.remove('is-in');

        this.index = (index + this.slides.length) % this.slides.length;
        const next = this.slides[this.index];
        next.hidden = false;
        // Force a reflow so the fade-up animation restarts on every change.
        void next.offsetWidth;
        next.classList.add('is-in');

        if (this.counter) this.counter.textContent = String(this.index + 1).padStart(2, '0');
      }
    }
  );
}
